<script>
import { ref } from "vue";
const value = ref();
const currentDate = ref(new Date());
export default {
  data() {
    return {
      isPasswordVisible: false,
      startdate: currentDate,
      dateFormat: "dd-MM-yyyy",
      showFilterInputs: false,
      EnqSel: ["Services", "Computer Repairs", "Plumbing"],
      SmithSelect: ["Name", "Jacob Kline", "William Smith"],
    };
  },
  methods: {
    toggleFilterInputs() {
      this.showFilterInputs = !this.showFilterInputs;
    },
    togglePasswordVisibility() {
      this.isPasswordVisible = !this.isPasswordVisible;
    },
  },
};
</script>
<template>
  <div class="provider-page">
    <provider-sidebar></provider-sidebar>
    <provider-header></provider-header>
    <!-- Page Wrapper -->
    <div class="page-wrapper">
      <div class="content container-fluid">
        <div class="row">
          <div class="d-flex justify-content-between align-items-center flex-wrap mb-4">
            <h5>Provider Enquiry</h5>
            <div class="d-flex align-items-center">
              <span class="fs-14 me-2">Sort</span>
              <div class="dropdown me-2">
                <a
                  href="javascript:void(0);"
                  class="dropdown-toggle bg-light-300"
                  data-bs-toggle="dropdown"
                >
                  Newly Added
                </a>
                <div class="dropdown-menu">
                  <a href="javascript:void(0);" class="dropdown-item active"
                    >Recently Added</a
                  >
                </div>
              </div>
              <a
                href="javascript:void(0);"
                class="tags d-flex justify-content-center align-items-center rounded me-2"
                ><i class="ti ti-printer"></i
              ></a>
              <a
                href="javascript:void(0);"
                class="tags d-flex justify-content-center align-items-center border rounded me-2"
                id="filter_search"
                @click="toggleFilterInputs"
                ><i class="ti ti-adjustments"></i
              ></a>
            </div>
          </div>
        </div>
        <div
          id="filter_inputs"
          v-bind:style="{ display: showFilterInputs ? 'block' : 'none' }"
        >
          <div class="row">
            <div class="col-lg-4 col-md-6">
              <div class="mb-3">
                <div class="sel-cal Calendar-icon">
                  <span><i class="ti ti-calendar-month"></i></span>
                  <date-picker
                    v-model="startdate"
                    placeholder=""
                    class="datetimepicker form-control"
                    :editable="true"
                    :clearable="false"
                    :input-format="dateFormat"
                  />
                </div>
              </div>
            </div>
            <div class="col-lg-4 col-md-6">
              <div class="mb-3">
                <vue-select :options="EnqSel" id="enqsel" placeholder="Services" />
              </div>
            </div>
            <div class="col-lg-4 col-md-6">
              <div class="mb-3">
                <vue-select :options="SmithSelect" id="smithselect" placeholder="Name" />
              </div>
            </div>
          </div>
        </div>
        <div class="row justify-content-center">
          <div class="col-xl-12 col-lg-12">
            <!-- Coupons List -->
            <div class="custom-datatable-filter table-responsive">
              <table class="table datatable">
                <thead class="thead-light">
                  <tr>
                    <th>Name</th>
                    <th>Enquired Service</th>
                    <th>Email</th>
                    <th>Phone Number</th>
                    <th>Date</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Lori Broaddus</td>

                    <td class="text-dark">Computer Repair</td>
                    <td>broaddus@example.com</td>
                    <td>+1 5647 878 4541</td>
                    <td>28 Sep 2024</td>
                    <td>
                      <div class="d-flex align-items-center">
                        <a
                          href="javascript:void(0);"
                          class="btn btn-light bg-light-500 d-flex align-items-center justify-content-center rounded-circle p-2 me-2"
                          ><i class="ti ti-messages"></i
                        ></a>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>Anthony Lewis</td>

                    <td class="text-dark">Car Repair Services</td>
                    <td>anthony@example.com</td>
                    <td>+1 4574 881 8977</td>
                    <td>02 Oct 2024</td>
                    <td>
                      <div class="d-flex align-items-center">
                        <a
                          href="javascript:void(0);"
                          class="btn btn-light bg-light-500 d-flex align-items-center justify-content-center rounded-circle p-2 me-2"
                          ><i class="ti ti-messages"></i
                        ></a>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>Harvey Smith</td>

                    <td class="text-dark">Steam Car Wash</td>
                    <td>harvey@example.com</td>
                    <td>+1 4259 352 3485</td>
                    <td>15 Oct 2024</td>
                    <td>
                      <div class="d-flex align-items-center">
                        <a
                          href="javascript:void(0);"
                          class="btn btn-light bg-light-500 d-flex align-items-center justify-content-center rounded-circle p-2 me-2"
                          ><i class="ti ti-messages"></i
                        ></a>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>Linda Ray</td>

                    <td class="text-dark">Building Construction</td>
                    <td>ray456@example.com</td>
                    <td>+1 5348 269 4583</td>
                    <td>26 Oct 2024</td>
                    <td>
                      <div class="d-flex align-items-center">
                        <a
                          href="javascript:void(0);"
                          class="btn btn-light bg-light-500 d-flex align-items-center justify-content-center rounded-circle p-2 me-2"
                          ><i class="ti ti-messages"></i
                        ></a>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>Elliot Murray</td>

                    <td class="text-dark">Building Construction</td>
                    <td>murray@example.com</td>
                    <td>+1 7869 342 9654</td>
                    <td>12 Nov 2024</td>

                    <td>
                      <div class="d-flex align-items-center">
                        <a
                          href="javascript:void(0);"
                          class="btn btn-light bg-light-500 d-flex align-items-center justify-content-center rounded-circle p-2 me-2"
                          ><i class="ti ti-messages"></i
                        ></a>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>Connie Waters</td>

                    <td class="text-dark">Interior Designing</td>
                    <td>connie@example.com</td>
                    <td>+1 8964 315 2496</td>
                    <td>18 Nov 2024</td>

                    <td>
                      <div class="d-flex align-items-center">
                        <a
                          href="javascript:void(0);"
                          class="btn btn-light bg-light-500 d-flex align-items-center justify-content-center rounded-circle p-2 me-2"
                          ><i class="ti ti-messages"></i
                        ></a>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>Lori Broaddus</td>

                    <td class="text-dark">Commercial Painting</td>
                    <td>broaddus@example.com</td>
                    <td>+1 2547 256 3145</td>
                    <td>22 Nov 2024</td>

                    <td>
                      <div class="d-flex align-items-center">
                        <a
                          href="javascript:void(0);"
                          class="btn btn-light bg-light-500 d-flex align-items-center justify-content-center rounded-circle p-2 me-2"
                          ><i class="ti ti-messages"></i
                        ></a>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>Rebecca Smtih</td>

                    <td class="text-dark">Plumbing Services</td>
                    <td>smtih@example.com</td>
                    <td>+1 4869 318 5485</td>
                    <td>12 Dec 2024</td>

                    <td>
                      <div class="d-flex align-items-center">
                        <a
                          href="javascript:void(0);"
                          class="btn btn-light bg-light-500 d-flex align-items-center justify-content-center rounded-circle p-2 me-2"
                          ><i class="ti ti-messages"></i
                        ></a>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <!-- /Coupons List -->
          </div>

          <div class="d-flex justify-content-between align-items-center">
            <div class="value d-flex align-items-center">
              <span>Show</span>
              <select>
                <option>7</option>
              </select>
              <span>entries</span>
            </div>
            <div class="d-flex align-items-center justify-content-center">
              <span class="me-2 text-gray-9">1 - 07 of 10</span>
              <nav aria-label="Page navigation">
                <ul class="paginations d-flex justify-content-center align-items-center">
                  <li class="page-item me-2">
                    <a
                      class="page-link-1 active d-flex justify-content-center align-items-center"
                      href="javascript:void(0);"
                      >1</a
                    >
                  </li>
                  <li class="page-item me-2">
                    <a
                      class="page-link-1 d-flex justify-content-center align-items-center"
                      href="javascript:void(0);"
                      >2</a
                    >
                  </li>
                  <li class="page-item">
                    <a
                      class="page-link-1 d-flex justify-content-center align-items-center"
                      href="javascript:void(0);"
                      >3</a
                    >
                  </li>
                </ul>
              </nav>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- /Page Wrapper -->
  </div>
  <!-- Delete Account -->
  <div class="modal fade custom-modal" id="del-account">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div
          class="modal-header d-flex align-items-center justify-content-between border-bottom"
        >
          <h5 class="modal-title">Delete Account</h5>
          <a href="javascript:void(0);" data-bs-dismiss="modal" aria-label="Close"
            ><i class="ti ti-circle-x-filled fs-20"></i
          ></a>
        </div>
        <form action="#">
          <div class="modal-body">
            <p class="mb-3">
              Are you sure you want to delete This Account? To delete your account, Type
              your password.
            </p>
            <div class="mb-0">
              <label class="form-label">Password</label>
              <div class="pass-group">
                <input
                  :type="isPasswordVisible ? 'text' : 'password'"
                  class="form-control pass-input"
                  placeholder="*************"
                />
                <span
                  @click="togglePasswordVisibility"
                  :class="
                    isPasswordVisible
                      ? 'toggle-password feather-eye'
                      : 'toggle-password feather-eye-off'
                  "
                ></span>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <a
              href="javascript:void(0);"
              class="btn btn-light me-2"
              data-bs-dismiss="modal"
              >Cancel</a
            >
            <button type="submit" class="btn btn-dark" data-bs-dismiss="modal">Delete Account</button>
          </div>
        </form>
      </div>
    </div>
  </div>
  <!-- /Delete Account -->
</template>
